<template>
  <div class="col-md-12 text-center file-upload-panel-container">
    <div class="file-upload-element" @click="showNativeUploadDialog()">
      <div
        href="file-upload-placeholder"
        v-if="uploadComponent.displayUploadPlaceholder"
      >
        <i class="fa fa-cloud-upload" aria-hidden="true"></i>
        <span>Click Here To Select Image</span>
      </div>
      <img
        src=""
        class="file-upload-preview"
        v-show="uploadComponent.displayPreviewImage"
        ref="file-upload-preview"
      />
    </div>
    <input
      type="file"
      name="image_url"
      id="file-upload-input"
      @change="loadChosenFile($event)"
      ref="file-upload-input"
    />
    <button class="btn btn-block btn-primary" @click="showNativeUploadDialog()">
      Select
    </button>
    <small v-if="error" class="form-text text-danger">{{
      error.join(" ")
    }}</small>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: [String, Number, Array],
      default: null,
    },
    loadedImage: {
      type: [String],
      default: null,
    },
  },
  data: function () {
    return {
      uploadComponent: {
        displayUploadPlaceholder: true,
        displayPreviewImage: false,
      },
    };
  },
  watch: {
    loadedImage: function () {
      if (this.loadedImage !== null) {
        this.loadProvidedImage();
      } else {
        this.resetPreview();
      }
    },
  },
  mounted() {
    if (this.loadedImage !== null) {
      this.loadProvidedImage();
    }
  },
  methods: {
    loadProvidedImage() {
      this.uploadComponent.displayUploadPlaceholder = false;
      this.uploadComponent.displayPreviewImage = true;
      this.$refs["file-upload-preview"].src = this.loadedImage;
    },

    resetPreview() {
      this.uploadComponent.displayUploadPlaceholder = true;
      this.uploadComponent.displayPreviewImage = false;
      this.$refs["file-upload-preview"].src = null;
    },

    showNativeUploadDialog() {
      let elem = this.$refs["file-upload-input"];
      elem.click();
    },

    loadChosenFile(event) {
      let self = this;
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = function (e) {
          self.uploadComponent.displayUploadPlaceholder = false;
          self.uploadComponent.displayPreviewImage = true;
          self.$refs["file-upload-preview"].src = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        this.uploadFile();
      }
    },

    async uploadFile() {
      let elem = this.$refs["file-upload-input"];
      if (elem.files[0] === undefined) {
        return;
      }

      try {
        let formData = new FormData();
        formData.append("image", elem.files[0]);
        let result = await axios.post(
          "v2/fabrics/fabric_families/upload",
          formData
        );
        let response = result.data;
        if (response.status === "OK") {
          this.$emit("image-url-updated", response.data);
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.$refs["file-upload-preview"].src = "";
          this.$emit("image-upload-failed", error);
        }
      }
    },
  },
};
</script>

<style scoped>
.header-row {
  margin-bottom: 20px;
}

.file-upload-panel-container {
  padding-top: 0px !important;
}

.file-upload-panel-container .file-upload-element {
  text-align: center;
  border-radius: 10px;
  background: #eee;
  border: 3px dashed #ccc !important;
  min-height: 270px;
  max-height: 270px;
}

.file-upload-panel-container .file-upload-element:hover {
  border: 3px dashed #aaa !important;
}

.file-upload-panel-container .file-upload-element i {
  margin-top: 90px;
  font-size: 80px;
  display: block;
}

.file-upload-panel-container #file-upload-input {
  display: none;
}

.file-upload-panel-container button {
  margin-top: 10px;
  cursor: pointer;
}

.file-upload-panel-container .file-upload-preview {
  width: 100%;
  max-height: 270px;
  border-radius: 10px;
  visibility: none;
}
</style>
